import {
    FETCH_ASSETAUM_BEGIN,
    FETCH_ASSETAUM_SUCCESS,
    FETCH_ASSETAUM_FAILURE
} from '../constants/assetAUM';

const initialState = {
    AssetAUMOpt: [],
    AssetAUM:0,
    StrategyAUM:0,
    FirmAUM:0,
    isLoading: false,
    error: ""
}


export const getAssetAUMOptReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETAUM_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETAUM_FAILURE:
            return {
                ...initialState,
                isLoading: true,
                AssetAUMOpt: null
            };
        case FETCH_ASSETAUM_SUCCESS:
            return {
                ...initialState,
                AssetAUMOpt: payload.AssetAUMOpt.AumData,
                AssetAUM:payload.AssetAUMOpt.AssetAUM,
                StrategyAUM:payload.AssetAUMOpt.StrategyAUM,
                FirmAUM:payload.AssetAUMOpt.FirmAUM,
                isLoading: false,
            };
        default:
            return state;
    }
}

export default getAssetAUMOptReducer
